import { useQuery } from '@tanstack/vue-query';
import { queries } from '@/api/queries';
import { getApiV2Me } from '@/api/pensa';

const useGetUser = () => {
  return useQuery({
    ...queries.customer.details,
    queryFn: async () => {
      const result = await getApiV2Me();
      return { ...result.customer.data, mentionMeToken: result.mentionMeToken } as const;
    },
    retry: false,
  });
};

export default useGetUser;
